import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
} from '@coreui/react-pro'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AdminAnnouncementService from 'src/service/AdminAnnouncementService'
import ToastComponent from 'src/components/common/TaostComponent'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const EditForm = (props) => {
  const [announcementDetail, setAnnouncementDetail] = useState({})
  const [value, setValue] = useState('')

  useEffect(() => {
    if (props.selectedId === props.announcementId) {
      AdminAnnouncementService.getAnnouncementDetail(props.announcementId).then((res) => {
        if (res.status === 200) {
          setAnnouncementDetail(res.data)
          setValue(res.data.payload?.description || '')
        }
      })
    }
  }, [props.selectedId, props.announcementId])

  const [loader, setLoader] = useState(false)

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required').max(100, '100 Character Limit is allowed.'),
  })

  const formik = useFormik({
    initialValues: {
      title: announcementDetail?.payload?.title || '',
      description: announcementDetail?.payload?.description || '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data) => {
      // Validate description is not empty
      if (!value || value.trim() === '<p><br></p>' || value.trim() === '') {
        ToastComponent('Description is required', 'error')
        return
      }

      const formData = new FormData()
      formData.append('announcementId', props.announcementId)
      formData.append('title', data.title)
      formData.append('description', value)

      setLoader(true)
      AdminAnnouncementService.editAnnouncement(formData)
        .then((res) => {
          if (res.status === 200) {
            props.fetchAnnouncements()
            props.toggleDetails(props.announcementId)
            ToastComponent(res.message, 'success')
            setLoader(false)
          } else {
            setLoader(false)
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log(e)
          setLoader(false)
        })
    },
  })

  const quillRef = useRef()

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['link'],
          [
            {
              color: [
                '#000000',
                '#e60000',
                '#ff9900',
                '#ffff00',
                '#008a00',
                '#0066cc',
                '#9933ff',
                '#ffffff',
                '#facccc',
                '#ffebcc',
                '#ffffcc',
                '#cce8cc',
                '#cce0f5',
                '#ebd6ff',
                '#bbbbbb',
                '#f06666',
                '#ffc266',
                '#ffff66',
                '#66b966',
                '#66a3e0',
                '#c285ff',
                '#888888',
                '#a10000',
                '#b26b00',
                '#b2b200',
                '#006100',
                '#0047b2',
                '#6b24b2',
                '#444444',
                '#5c0000',
                '#663d00',
                '#666600',
                '#003700',
                '#002966',
                '#3d1466',
              ],
            },
          ],
        ],
      },
    }),
    [],
  )

  return (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={12}>
          <CFormLabel className="fw-bold" htmlFor="title">
            Title
          </CFormLabel>
          <input
            type="text"
            name="title"
            className={
              'form-control' + (formik.errors.title && formik.touched.title ? ' is-invalid' : '')
            }
            id="title"
            placeholder="Announcement Title"
            value={formik.values?.title}
            onChange={formik.handleChange}
          />
          {formik.errors.title && formik.touched.title && (
            <CFormFeedback invalid>{formik.errors.title}</CFormFeedback>
          )}
        </CCol>

        <CCol md={12}>
          <CFormLabel className="fw-bold" htmlFor="description">
            Description
          </CFormLabel>
          <ReactQuill
            theme="snow"
            ref={quillRef}
            value={value}
            onChange={setValue}
            modules={modules}
            style={{ border: '1px solid' }}
            placeholder="Enter announcement description"
          />
        </CCol>

        <CCol md={6} className="mt-3">
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Submit
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default EditForm
